<template>
  <div class="card mb-5 mb-xxl-8">
    <div v-show="isReady" class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <!--begin::Card header-->
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('shop.product_entry') }}</h3>
        </div>
        <div class="card-toolbar" v-if="!shop?.archive">
          <select v-if="$can('entry_boutique_create')"
                  name="entry_action"
                  v-model="selectedAction"
                  class="form-select form-select-solid kt_select2"
                  data-control="select2"
                  data-search="true"
                  data-allow-clear="true"
                  :data-placeholder="$t('store.entrie.make_entry')"
                  style="width: 150px;">
            <option value="add_item">{{ $t('store.entrie.add') }}</option>
            <option value="add_by_category">{{ $t('store.entrie.add_by_cat') }}</option>
          </select>


        </div>
      </div>
      <div class="card-body">
        <!--begin::Layout-->
        <div class="row">
          <!--begin::Table-->
          <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_shop_entries">
            <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-100px">{{ $t('store.entrie.numero') }}</th>
              <th class="min-w-100px">{{ $t('shop.date') }}</th>
              <th class="min-w-100px">{{ $t('shop.store') }}</th>
              <th class="min-w-100px">{{ $t('shop.user_validate_entry') }}</th>
              <th class="min-w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
    <div class="card mb-5 mb-xl-10" v-show="!isReady">
      <Loader text="Loading..." />
    </div>
    <div class="modal bg-white fade" tabindex="-1" id="kt_modal_2">
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content shadow-none">
          <div class="modal-header">
            <div class="row modal-title" style="width: 100%">
              <h5 class="mt-2">{{ $t('shop.shop_details_entry') }}: {{ entryInfo.numero }}</h5>
              <h5 class="mt-4">{{ $t('store.output.create.date') }} {{ entryInfo.date }}</h5>
              <h5 class="mt-2">
                <bouton type="button" :title="currency.currency_symbol ? currency.currency_name : ''" class="btn btn-light-primary">
                  {{ $t('delivery.currency') }} ({{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }})
                </bouton>
              </h5>
            </div>
            <div class="entry-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x">x</span>
            </div>
          </div>
          <div v-show="isDisponible" class="modal-body">
            <div v-if="(storeSender != null) && (storeSender != 'null')" class="card">
              <div class="row">
                <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_shop_entries">
                  <thead>
                  <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th class="min-w-100px">{{ $t('shop.designation') }}</th>
                    <th class="min-w-100px">{{ $t('shop.lot_unite') }}</th>
                    <th class="min-w-100px">{{ $t('shop.status') }}</th>
                    <th class="min-w-100px">{{ $t('shop.quantity_send') }}</th>
                    <th class="min-w-100px">{{ $t('shop.received_quantity') }}</th>
                    <th class="min-w-100px">{{ $t('product.buy_price') }}</th>
                    <th class="min-w-100px">{{ $t('product.sell_price_ht') }}</th>
                    <th class="min-w-100px">{{ $t('product.taxes') }}</th>
                    <th class="min-w-100px">{{ $t('product.sell_price_ttc') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="entry in entryInfo.productSaleElements.slice(0, 10)" :key="entry.name">
                    <td> {{ entry.name }} </td>
                    <td> {{ entry.product_lot_id ? entry.product_lot_id : $t('shop.unite') }} </td>
                    <td class="fw-bolder">
                        <span class="light-primary" v-show="entry.status == 'conform'">
                          {{ $t('shop.shop_conform') }} </span>
                      <span class="light-danger" v-show="entry.status == 'unconform'">
                          {{ $t('shop.shop_unconform') }} </span>
                    </td>
                    <td class="fw-bolder"> {{ entry.quantity_lot ? entry.quantity_lot : entry.product_quantity }} </td>
                    <td class="fw-bolder"> {{ entry.received_quantity }} </td>
                    <td class="fw-bolder"> {{ $formatLocalAmount(entry.buy_price) }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }}</td>
                    <td class="fw-bolder"> {{ $formatLocalAmount(entry.sell_price) }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }}</td>
                    <td class="fw-bolder">
                        <span v-if="showProductTaxe(entry)?.length">
                          <span v-for="taxe in showProductTaxe(entry)" :key="taxe.id" class="light-primary me-1">
                          {{ taxe.title }}
                          <span v-if="taxe.type == 'percent'">({{ taxe.amount }}%)</span>
                          <span v-else >({{ taxe.amount }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }})</span>
                          </span>
                        </span>
                      <span class="light-primary" v-else>
                          ----
                        </span>
                    </td>
                    <td class="fw-bolder"> {{ $formatLocalAmount(showProductPrixTTC(entry)) }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="card">
              <div class="row">
                <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_shop_entries">
                  <thead>
                  <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th class="min-w-100px">{{ $t('shop.designation') }}</th>
                    <th class="min-w-100px">{{ $t('shop.lot_unite') }}</th>
                    <th class="min-w-100px">{{ $t('shop.quantity') }}</th>
                    <th class="min-w-100px">{{ $t('product.buy_price') }}</th>
                    <th class="min-w-100px">{{ $t('product.sell_price_ht') }}</th>
                    <th class="min-w-100px">{{ $t('product.taxes') }}</th>
                    <th class="min-w-100px">{{ $t('product.sell_price_ttc') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="entry in entryInfo.productSaleElements.slice(0, 10)" :key="entry.name">
                    <td> {{ entry.name }} </td>
                    <td> {{ entry.product_lot_id ? entry.product_lot_id : $t('shop.unite') }} </td>
                    <td class="fw-bolder"> {{ entry.quantity_lot ? entry.quantity_lot : entry.product_quantity }} </td>
                    <td class="fw-bolder"> {{ $formatLocalAmount(entry.buy_price) }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }}</td>
                    <td class="fw-bolder"> {{ $formatLocalAmount(entry.sell_price) }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }}</td>
                    <td class="fw-bolder">
                        <span v-if="showProductTaxe(entry)?.length">
                          <span v-for="taxe in showProductTaxe(entry)" :key="taxe.id" class="light-primary me-1">
                          {{ taxe.title }}
                          <span v-if="taxe.type == 'percent'">({{ taxe.amount }}%)</span>
                          <span v-else >({{ taxe.amount }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }})</span>
                          </span>
                        </span>
                      <span class="light-primary" v-else>
                          ----
                        </span>
                    </td>
                    <td class="fw-bolder"> {{ $formatLocalAmount(showProductPrixTTC(entry)) }} {{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-body loader" v-show="!isDisponible">
            <Loader text="Loading..." />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light-danger" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal bg-white fade" tabindex="-1" id="entryItemsModal">
      <div class="modal-dialog modal-fullscreen">
        <form @submit.prevent="addEntryProductsData" class="modal-content shadow-none">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('shop.product_list') }}</h5>
            <div class="row">
              <div class="col-sm-4">
                <div class="d-flex align-items-center flex-equal fw-row me-4 order-2" data-bs-toggle="tooltip"
                     data-bs-trigger="hover">
                  <div class="fs-6 fw-bolder text-gray-700 text-nowrap">
                    {{ $t('store.output.create.date') }}</div>
                  <div class="position-relative d-flex align-items-center w-200px">
                    <input class="form-control form-control-solid fw-bolder pe-5 kt_voucher_date"
                           v-model="formEntryContent.date" required :placeholder="$t('store.entrie.create.date_placeholder')"
                           name="invoice_date" />
                    <span class="svg-icon svg-icon-2 position-absolute ms-4 end-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                            fill="currentColor" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <bouton :title="currency.currency_symbol ? currency.currency_name : ''" class="btn btn-light-primary">
                  {{ $t('delivery.currency') }} ({{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }})
                </bouton>
              </div>
              <div class="col-sm-4">
                <div class="d-flex flex-center fw-row order-1 order-2"
                     data-bs-toggle="tooltip" data-bs-trigger="hover" :title="formEntryContent.numero">
                  <span class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('shop.entries') }} :
                  </span>
                  <input type="text" class="form-control form-control-transparent fw-bolder fs-3 w-250px" disabled
                         :value="formEntryContent.numero" />
                </div>
              </div>
            </div>
            <div class="entry-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x">x</span>
            </div>
          </div>

          <div class="modal-body">
            <div class="card">
              <div class="card-body">
                <div class="row bg-light rounded py-6 my-2" v-for="(item, index) in formEntryContent.products"
                     :key="index">
                  <div class="col">
                    <div class="row">
                      <div class="col-md-3  my-2">
                        <label class="required form-label">{{ $t('store.product_placeholder') }}</label>
                        <select
                            :id="'remove_enty_product' + index"
                            required
                            :data-product-key="index"
                            class="form-select kt_select2 h-50px"
                            data-control="select2"
                            name="product"
                            v-model="item.id"
                            @change="handleProductChange(index)"
                            data-dropdown-parent="#entryItemsModal"
                            :data-placeholder="$t('store.product_placeholder')"
                            data-allow-clear="false"
                        >
                          <option></option>
                          <optgroup v-for="group in groupedProductSaleElements(index)" :key="group.category_id" :label="group.category_name">
                            <option v-for="product in group.products" :key="product.id" :value="product.id">
                              {{ product.declination_title }}
                            </option>
                          </optgroup>
                        </select>

                      </div>
                      <div class="col-md-3  my-2">
                        <label class="form-label">{{ $t('store.entrie.create.lot') }}</label>
                        <select :id="'remove_entry_lot' + index" :data-product-key="index"
                                class="form-select kt_select2 h-50px" data-control="select2" name="lot" v-model="item.product_lot_id"
                                data-dropdown-parent="#entryItemsModal" :data-placeholder="$t('store.entrie.create.lot')"
                                data-allow-clear="true">
                          <option v-for="lot in filterProductSaleElementLots(index, item.id)" :key="lot.id" :value="lot.id">
                            {{ lot.lot.name }} ({{ lot.lot.item_number }})
                          </option>
                        </select>
                      </div>
                      <div class="col-md-2  my-2">
                        <label class="required form-label">{{ $t('store.output.create.product_quantity') }}</label>
                        <input required type="number" min="0" v-model="item.quantity" class="form-control h-50px"
                               name="date" :placeholder="$t('store.output.create.product_quantity')" />
                      </div>
                      <div class="col-md-2  my-2">
                        <label class="form-label"> {{ $t('product.stock_security') }}</label>
                        <input type="number" min="0" class="form-control h-50px" v-model="item.stock_security"
                               required />
                      </div>
                      <div class="col-md-2  my-2">
                        <label class="form-label"> {{ $t('product.stock_alert') }}</label>
                        <input type="number" min="0" class="form-control h-50px" v-model="item.stock_alert" required />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3  my-2">
                        <label class="form-label">{{ $t('product.buy_price') }}</label>
                        <VueNumberFormat class="form-control h-50px" name="buyPrice"   v-model:value="item.buyPrice"   :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                        ></VueNumberFormat>
                      </div>
                      <div class="col-md-3  my-2">
                        <label class=" required form-label">{{ $t('product.sell_price_ht') }}</label>
                        <VueNumberFormat class="form-control h-50px" name="sellPrice"   v-model:value="item.sellPrice"   placeholder="$t('product.sell_price_ht')" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                        ></VueNumberFormat>
                      </div>
                      <div class="col-md-3  my-2">
                        <div class="row">
                          <label class="d-flex align-items-center fs-6 fw-bold">
                            <label class="form-label">{{ $t('product.taxes') }}</label>
                          </label>
                          <div class="col-md-10 col-sm-12">
                            <select :id="'remove_enty_taxe' + index" name="taxes[]" class="form-select kt_select2 h-50px" data-control="select2"
                                    v-model="item.taxes"
                                    :data-placeholder="$t('product.taxes')"
                                    data-dropdown-parent="#entryItemsModal"
                                    :data-product-key="index"
                                    multiple="multiple"
                                    data-search="true">
                              <option value="" selected></option>
                              <option v-for="taxe in getTaxes" :key="taxe.id" :value="taxe.id">{{ taxe.title }} </option>
                            </select>
                          </div>
                          <div class="col-md-2 col-sm-12">
                            <div class=" input-group-append">
                              <button @click="openCreateTaxetModal" type="button" class="btn btn-sm btn-icon btn-light-primary"
                                      style="width: 40px;height: 41px">
                                <span class="svg-icon svg-icon-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="300" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)"
                                          fill="currentColor" />
                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3  my-2">
                        <label class="form-label">{{ $t('product.sell_price_ttc') }}</label>
                        <input readonly :value="prixTTC(index)" type="number" min="0" class="form-control h-50px"
                               :placeholder="$t('product.sell_price_ttc')" />
                      </div>
                    </div>
                  </div>
                  <div class="col-1">
                    <button @click.prevent="dropShopLigne(index)" type="button"
                            class="btn btn-sm btn-icon text-danger btn-active-color-danger" data-kt-element="remove-item">
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path
                              d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                              fill="currentColor" />
                          <path opacity="0.5"
                                d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                fill="currentColor" />
                          <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                fill="currentColor" />
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-8"></div>
                  <div class="col-sm-4 text-end">
                    <button @click.prevent="addLigne()" type="button" class="btn btn-light-primary btn-sm my-3">
                      <i class="fa fa-plus"></i>
                      {{ $t('product.add_product') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" id="kt_submit_create_entry" class="btn btn-sm btn-primary fw-bolder">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{ $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
        </form>
      </div>
    </div>


    <div class="modal bg-white fade" tabindex="-1" id="entryByCategoryModal">
      <div class="modal-dialog modal-fullscreen">
        <form @submit.prevent="submitEntryByCategory" class="modal-content shadow-none">

          <!-- HEADER -->
          <!-- HEADER -->
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('shop.product_list') }}</h5>
            <div class="row">
              <div class="col-sm-4">
                <div class="d-flex align-items-center flex-equal fw-row me-4 order-2" data-bs-toggle="tooltip"
                     data-bs-trigger="hover">
                  <div class="fs-6 fw-bolder text-gray-700 text-nowrap">
                    {{ $t('store.output.create.date') }}</div>
                  <div class="position-relative d-flex align-items-center w-200px">
                    <input class="form-control form-control-solid fw-bolder pe-5 kt_voucher_date"
                           v-model="formEntryContent.date" required :placeholder="$t('store.entrie.create.date_placeholder')"
                           name="invoice_date" />
                    <span class="svg-icon svg-icon-2 position-absolute ms-4 end-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                            fill="currentColor" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <bouton :title="currency.currency_symbol ? currency.currency_name : ''" class="btn btn-light-primary">
                  {{ $t('delivery.currency') }} ({{ currency.currency_symbol ? currency.currency_symbol : currency.symbol_native }})
                </bouton>
              </div>
              <div class="col-sm-4">
                <div class="d-flex flex-center fw-row order-1 order-2"
                     data-bs-toggle="tooltip" data-bs-trigger="hover" :title="formEntryContent.numero">
                  <span class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('shop.entries') }} :
                  </span>
                  <input type="text" class="form-control form-control-transparent fw-bolder fs-3 w-250px" disabled
                         :value="formEntryContent.numero" />
                </div>
              </div>
            </div>
            <div class="entry-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x">x</span>
            </div>
          </div>


          <!-- BODY -->
          <div class="modal-body">

            <!-- Sélection Catégories -->
            <div class="row bg-light rounded p-5 mb-5">
              <div class="col-md-12">
                <label class="required form-label">{{ $t('product.category') }}</label>
                <select
                    :id="'category_select_0'"
                    class="form-select kt_select2 h-50px"
                    data-control="select2"
                    data-dropdown-parent="#entryByCategoryModal"
                    multiple
                    v-model="selectedCategories"
                >
                  <template v-for="category in getCategories" :key="category.id">
                    <!-- Parent non sélectionnable -->
                    <option disabled class="parent-option">{{ category.name }}</option>

                    <!-- Sous-catégories sélectionnables -->
                    <option
                        v-for="sub in category.childrens"
                        :key="sub.id"
                        :value="sub.id"
                    >
                      &nbsp;&nbsp;— {{ sub.name }}
                    </option>
                  </template>
                </select>
              </div>
            </div>


            <!-- Liste Produits des catégories sélectionnées -->
            <div class="card" v-if="formByCategory?.products?.length > 0">
              <div class="card-body">

                <div class="alert alert-info fw-bold">
                  {{ $t('store.entrie.products_found') }} : {{ formByCategory.products?.length }}
                </div>

                <div class="row bg-light rounded py-6 my-2"
                     v-for="(item, index) in formByCategory.products"
                     :key="index">

                  <div class="col">
                    <div class="row">

                      <!-- Nom produit + suppression -->
                      <div class="col-md-4 my-2">
                        <label class="form-label">{{ item.name }}</label>
                        <button type="button"
                                class="btn btn-sm btn-light-danger ms-2"
                                @click="removeProductCategory(index)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>

                      <!-- Quantité -->
                      <div class="col-md-2 my-2">
                        <label class="required form-label">{{ $t('store.output.create.product_quantity') }}</label>
                        <input type="number" min="1" v-model="item.quantity"
                               class="form-control h-50px" required />
                      </div>

                      <!-- Prix achat -->
                      <div class="col-md-2 my-2">
                        <label class="form-label">{{ $t('product.buy_price') }}</label>
                        <VueNumberFormat class="form-control h-50px"
                                         v-model:value="item.buyPrice"
                                         :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }" />
                      </div>

                      <!-- Prix vente -->
                      <div class="col-md-2 my-2">
                        <label class="form-label required">{{ $t('product.sell_price_ht') }}</label>
                        <VueNumberFormat class="form-control h-50px"
                                         v-model:value="item.sellPrice"
                                         :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }" />
                      </div>

                      <!-- Taxes -->
                      <div class="col-md-2 my-2">
                        <label class="form-label">{{ $t('product.taxes') }}</label>
                        <select class="form-select kt_select2 h-50px"
                                data-control="select2"
                                data-dropdown-parent="#entryByCategoryModal"
                                multiple
                                v-model="item.taxes">
                          <option v-for="t in getTaxes" :value="t.id">{{ t.title }}</option>
                        </select>
                      </div>

                    </div>

                    <div class="row">

                      <!-- Stock sécurité -->
                      <div class="col-md-2 my-2">
                        <label class="form-label">{{ $t('product.stock_security') }}</label>
                        <input type="number" min="0" v-model="item.stock_security" class="form-control h-50px" />
                      </div>

                      <!-- Stock alerte -->
                      <div class="col-md-2 my-2">
                        <label class="form-label">{{ $t('product.stock_alert') }}</label>
                        <input type="number" min="0" v-model="item.stock_alert" class="form-control h-50px" />
                      </div>

                      <!-- Lot -->
                      <div class="col-md-3  my-2">
                        <label class="form-label">{{ $t('store.entrie.create.lot') }}</label>
                        <select class="form-select kt_select2 h-50px"
                                data-control="select2"
                                data-dropdown-parent="#entryByCategoryModal"
                                v-model="item.product_lot_id">
                          <option v-for="lot in filterLots(item.id)" :value="lot.id">
                            {{ lot.lot.name }} ({{ lot.lot.item_number }})
                          </option>
                        </select>
                      </div>

                      <!-- Prix TTC auto -->
                      <div class="col-md-2 my-2">
                        <label class="form-label">{{ $t('product.sell_price_ttc') }}</label>
                        <input type="number" readonly :value="priceTTC(item)"
                               class="form-control h-50px" />
                      </div>

                    </div>

                  </div>

                </div>

              </div>
            </div>

          </div>

          <!-- FOOTER -->
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" id="kt_submit_create_category_entry" class="btn btn-sm btn-primary fw-bolder">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{ $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>

        </form>
      </div>
    </div>

    <div class="modal fade" id="createTaxeModal">
      <form @submit.prevent="createTaxData" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.add') }}</h5>
            <div class="entry-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x"></span>
            </div>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column mb-8 fv-row">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('taxe.title') }}</span>
              </label>
              <input type="text" class="form-control form-control-solid" v-model="formCreateTaxeData.title" required
                     :placeholder="$t('taxe.title_placeholder')" />
            </div>
            <div class="d-flex flex-column mb-8 fv-row">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('taxe.type') }}</span>
              </label>
              <select name="tax_type" class="form-select form-select-solid kt_select2" data-control="select2"
                      v-model="formCreateTaxeData.type" required data-search="true"
                      :data-placeholder="$t('taxe.type_placeholder')">
                <option></option>
                <option value="amount">{{ $t('taxe.type_amount') }}</option>
                <option value="percent">{{ $t('taxe.type_percent') }}</option>
              </select>
            </div>
            <div class="d-flex flex-column mb-8 fv-row" v-if="formCreateTaxeData.type === 'amount'">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('taxe.amount') }}</span>
              </label>
              <input type="text" class="form-control form-control-solid"
                     v-model="formCreateTaxeData.amount" required :placeholder="$t('taxe.amount_placeholder')" />
            </div>
            <div class="d-flex flex-column mb-8 fv-row" v-if="formCreateTaxeData.type === 'percent'">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('taxe.percent') }}</span>
              </label>
              <div class="input-group mb-5">
                <input type="text" class="form-control form-control-solid"
                       v-model="formCreateTaxeData.amount" required :placeholder="$t('taxe.percent_placeholder')" />
                <span class="input-group-text" id="basic-addon2">%</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" id="kt_submit_create_taxe" class="btn btn-sm btn-primary fw-bolder">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{ $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import VueNumberFormat from 'vue-number-format'
import {formatDate} from "@/mixins/Helper";
import Loader from "@/components/Loader.vue";
export default {
  components: { VueNumberFormat, Loader },
  name: "Entry",
  props: {
    shop: {
      type: Object,
      default: {}
    },
    entryCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      entryInfo: {
        productSaleElements: [],
      },
      selectedAction: '',
      selectedCategories: [], // pour plusieurs catégories
      formByCategory: {
        date: this.formatDate(),
        numero: '',
        status: 'Draft',
        shop_id: this.$route.params.id,
        products: [] // produits de toutes les catégories sélectionnées
      },
      categoryProducts: [] ,// pour affichage et info

      formEntryContent: {
        shop_id: this.$route.params.id,
        numero: '',
        date: this.formatDate(),
        status: 'Draft',
        products: [
          {
            id: null,
            quantity: null,
            comments: '',
            buyPrice: 0,
            sellPrice: null,
            taxes: [],
            stock_alert: 10,
            stock_security: 10,
            product_lot_id: null,
            otherPrice: [
              {
                name: "",
                value: ""
              }
            ]
          }
        ],
      },
      products: [],
      formCreateTaxeData: {
        title: '',
        amount: '',
        type: '',
        countries: []
      },
      isDisponible: false,
      currency: [],
      storeSender: null,
      isReady: false,
      productLot: [],
      porductSaleElementLots: []
    }
  },

  computed: {
    ...mapGetters('products', ['getProductSaleElements']),
    ...mapGetters('taxes', ['getTaxes']),
    ...mapGetters('categories', ['getCategories']),

    shopPrefix() {
      return this.shop.prefix ?  this.$addYearToPrefixe(this.shop.prefix)  : 'ENT/' + this.shop.name.slice(0, 3).toUpperCase() + '/' + (new Date()).getFullYear()
    },

    // Catégories à plat (parents + sous-catégories), pour retrouver le nom
    // d'une product_category_id sans reparcourir l'arbre à chaque produit.
    allCategoriesFlat() {
      const flat = []
      this.getCategories.forEach((category) => {
        if (category.childrens && category.childrens.length) {
          flat.push(...category.childrens)
        } else {
          flat.push(category)
        }
      })
      return flat
    },

    productSaleElements() {
      if (this.formEntryContent.products && this.formEntryContent.products?.length && this.formEntryContent.products[0].id !== null) {
        return this.getProductSaleElements.filter(product => !this.formEntryContent.products.some(p => p.id === product.id))
      }
      return this.getProductSaleElements
    }
  },
  watch: {
    'formEntryContent.products.length': function () {
      this.$nextTick(() => {
        this.initSelect2()
        $(".kt_voucher_date").flatpickr({
          dateFormat: "d/m/Y",
        })
      })
    },
    '$i18n.locale' : function(value){
      if(value && this.table){
        this.$nextTick(() =>   this.fetchDatas())
      }
    },
    '$route.params.id' : function(newId, oldId){
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // la datatable garde les entrées de l'ancienne boutique consultée.
      if (newId && newId !== oldId) this.fetchDatas()
    },
  },
  async mounted() {
    this.isReady = false
    this.fetchDatas()
    this.loadTaxes()
    this.loadAllProductSale()
    this.loadCategories()
    this.initCurrency()
    this.initSelect2()
    this.$nextTick(() => {
      this.initSelect2Categories();
    });

    this.initProductSaleElementLots()
    $(document).on("click", "#kt_datatable_shop_entries .validate_entry_btn", (e) => {
      this.$router.push('/admin/shops/' + this.$route.params.id + '/view/validate/' + e.target.getAttribute('data-id') + '/entry')
    });

    $(document).on("click", "#kt_datatable_shop_entries .view_btn", async (e) => {
      let id_entry = e.target.getAttribute('data-id')
      this.storeSender = e.target.getAttribute('data-store')
      if (id_entry) {
        await this.detailProductBonModalOpen(id_entry)
      }
    });
    $(".kt_voucher_date").flatpickr({
      dateFormat: "d/m/Y",
    })
    this.$nextTick(() => {
      this.initSelect2Events();
    });
    this.isReady = true

  },

  methods: {
    ...mapActions('shop', [
      'showShop',
      'showShopEntryProduct',
      'addProductsToShop',
      'getCurrency',
        'addProductEntryByCategory'
    ]),
    ...mapActions('products', ['loadAllProductSale', 'getProductSaleElementLot', 'listProductLots']),
    ...mapActions('categories', ['loadCategories']),
    ...mapActions('taxes', [
      'loadTaxes',
      'createTaxe'
    ]),
    initSelect2Events() {
      this.$nextTick(() => {
        this.formEntryContent.products.forEach((_, index) => {
          const selector = `#remove_enty_product${index}`;
          $(selector).on('select2:select', () => {
            this.handleProductChange(index);
          });
        });
      });
    },
    formatDate() {
      let date = new Date().getDate();
      let month = new Date().getMonth() + 1;
      let year = new Date().getFullYear();
      return `${(date < 10) ? '0' + date : date}/${(month < 10) ? '0' + month : month}/${year}`;
    },
    async initProductSaleElementLots(){
      let response = await this.listProductLots()
      this.porductSaleElementLots = response.data
    },
    formatNumberForVue(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    prixTTC(index) {
      const produit = this.formEntryContent.products[index];
      const taxesProduit = this.getTaxes ? this.getTaxes.filter(taxe => produit.taxes.includes(taxe.id)) : [];
      let prixHT = parseFloat(produit.sellPrice);
      this.formEntryContent.products[index].sellPrice = prixHT;
      this.formEntryContent.products[index].buyPrice = parseFloat(this.formEntryContent.products[index].buyPrice)
      taxesProduit.forEach(taxe => {
        if (taxe.type === 'percent') {
          prixHT *= 1 + parseFloat(taxe.amount) / 100;
        } else if (taxe.type === 'amount') {
          prixHT += parseFloat(taxe.amount);
        }
      });
      return Math.round(prixHT * 100) / 100;
    },
    async initCurrency(){
      let response = await this.getCurrency()
      this.currency = response.data
    },
    showProductPrixTTC(product) {
      const taxesProduit = this.getTaxes ? this.getTaxes.filter(taxe => product.taxes.includes(taxe.id)) : [];
      let prixHT = parseFloat(product.sell_price);
      taxesProduit.forEach(taxe => {
        if (taxe.type === 'percent') {
          prixHT *= 1 + parseFloat(taxe.amount) / 100;
        } else if (taxe.type === 'amount') {
          prixHT += parseFloat(taxe.amount);
        }
      });
      return Math.round(prixHT * 100) / 100;
    },
    showProductTaxe(product){
      const taxes = this.getTaxes ? this.getTaxes.filter(taxe => product.taxes.includes(taxe.id)) : [];
      return taxes
    },
    getTaxIds(index) {
      const produit = this.formEntryContent.products[index];
      const taxIds = [];
      this.getProductSaleElements.forEach((item) => {
        if (item.id === produit.id) {
          this.formEntryContent.products[index].stock_alert = item.stock_alert
          this.formEntryContent.products[index].stock_security = item.stock_security
          item.taxes.forEach((tax) => {
            if (tax.shop_id === this.shop.id) {
              tax.taxes.forEach((innerTax) => {
                taxIds.push(innerTax.id);
              });
            }
          });
        }
      });
      return taxIds;
    },
    handleProductChange(index) {
      const selectedProductId = this.formEntryContent.products[index].id;
      const selectedProduct = this.getProductSaleElements.find(p => p.id === selectedProductId);
      if (selectedProduct) {
        console.log(selectedProduct,'kik')
        this.formEntryContent.products[index].buyPrice = selectedProduct.price || 0;
        this.formEntryContent.products[index].sellPrice = selectedProduct.price || 0;
      }
    },

    filterProductSaleElements(key) {
      let productBeforeKey = [];

      for (let i = 0; i < key; i++) {
        const product = this.formEntryContent.products[i];
        if (this.filterProductSaleElementLots(i, product.id)?.length === 0) {
          productBeforeKey.push(product.id);
        }
      }

      let product_lists = this.getProductSaleElements.filter(product => !productBeforeKey.includes(product.id));
      return this.sortByKey(product_lists, "name");
    },

    // Regroupe la liste des produits sélectionnables par catégorie, pour un
    // <select> avec des <optgroup> — même présentation que sur le pack.
    groupedProductSaleElements(key) {
      const groups = {}

      this.filterProductSaleElements(key).forEach((product) => {
        const categoryId = product.product_category_id || 'none'
        if (!groups[categoryId]) {
          const category = this.allCategoriesFlat.find(c => c.id === categoryId)
          groups[categoryId] = { category_id: categoryId, category_name: category?.name || '—', products: [] }
        }
        groups[categoryId].products.push(product)
      })

      return Object.values(groups).sort((a, b) => a.category_name.localeCompare(b.category_name))
    },
    filterProductSaleElementLots(key, product_sale_element_id) {
      if(product_sale_element_id != null){
        let newProductLots = this.porductSaleElementLots.filter(lot => lot.product_sale_element_id === product_sale_element_id);
        let productBeforeKey = this.formEntryContent.products
            .filter((data, i) => i < key)
            .map(data => data.product_lot_id);

        return newProductLots.filter(lot => !productBeforeKey.includes(lot.id));
      }
      return []
    },



    handleAction() {
      switch (this.selectedAction) {
        case 'add_item':
          this.toggleItemEntryModal()
          break
        case 'add_by_category':
          this.toggleItemCategoryEntryModal()
          break
      }
      // Réinitialiser la sélection
      this.selectedAction = ''
    },

    toggleItemEntryModal() {
      $("#entryItemsModal").modal('toggle')
      this.formEntryContent.numero = this.shopPrefix + '/' + this.$incrementValue(this.entryCount)

    },
    toggleItemCategoryEntryModal() {
      $("#entryByCategoryModal").modal('toggle')
      this.formEntryContent.numero = this.shopPrefix + '/' + this.$incrementValue(this.entryCount)

    },
    openCreateTaxetModal() {
      $('#createTaxeModal').modal('toggle')
    },

    async detailProductBonModalOpen(entry_id) {
      this.isDisponible = false
      let response = await this.showShopEntryProduct({ shop_id: this.$route.params.id, entry_id: entry_id })
      this.entryInfo = response.data.entry_shop
      this.entryInfo.productSaleElements = response.data.productSaleElements_collection
      this.isDisponible = true
    },
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key]?.toLowerCase();
        var y = b[key]?.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },
    addLigne() {
      this.formEntryContent.products.push(
          {
            id: null,
            quantity: null,
            comments: '',
            buyPrice: 0,
            sellPrice: 0,
            taxes: [],
            stock_alert: 10,
            stock_security: 10,
            product_lot_id: null,
            otherPrice: [
              {
                name: "",
                value: ""
              }
            ]
          }

      )
      this.$nextTick(() => {
        this.initSelect2()
      })
      this.$nextTick(() => {
        this.initSelect2Events(); // Réattache les événements
      });
    },
    initSelect2Categories() {
      const selector = '#category_select_0';

      $(selector).select2();

      // Événement pour mettre à jour `selectedCategories` et charger les produits
      $(selector).on('change', (e) => {
        let selected = [];
        for (let i = 0; i < e.target.selectedOptions?.length; i++) {
          const val = e.target.selectedOptions[i].value;
          if (val !== '' && val !== undefined) selected.push(val);
        }

        this.selectedCategories = selected;
        this.loadProductsBySelectedCategories();
      });
    },

    initSelect2() {
      $(".kt_select2").select2()
      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'product':
            this.formEntryContent.products[e.target.getAttribute('data-product-key')].id = e.target.value;
            this.formEntryContent.products[e.target.getAttribute('data-product-key')].product_lot_id = null
            const index = e.target.getAttribute('data-product-key');
            const taxIds = this.getTaxIds(index);
            this.formEntryContent.products[index].taxes = taxIds;
            $(".kt_select2[data-product-key='" + index + "'][name='taxes[]']").val(taxIds).trigger('change');
            break;
          case 'lot':
            this.formEntryContent.products[e.target.getAttribute('data-product-key')].product_lot_id = e.target.value;
            break;
          case 'taxes[]':
            let result = [];
            for (var i = 0, iLen = e.target.selectedOptions?.length; i < iLen; i++) {
              if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
                result.push(e.target.selectedOptions[i].value);
              }
            }
            this.formEntryContent.products[e.target.getAttribute('data-product-key')].taxes = result
            break;
          case 'tax_type':
            this.formCreateTaxeData.type = e.target.value
            break;
          case 'entry_action':
            switch(e.target.value) {
              case 'add_item':
                this.toggleItemEntryModal();
                break;
              case 'add_by_category':
                this.toggleItemCategoryEntryModal();
                break;
            }
            // réinitialiser le select si nécessaire
            break;

          default:
            break;
        }
      });
    },

    formatProduct(items) {
      return (items.attribut?.length > 0) ? ' (' + items.attribut + ')' : '';
    },
    async addEntryProductsData() {
      this.$loading('kt_submit_create_entry')
      let response = {}
      try {
        await this.addProductsToShop(this.formEntryContent)
        this.$emit('reloadEditData')
        window.toastr['success'](i18n.global.t('notification.store.entrie_create'))
        this.formEntryContent = {
          shop_id: this.$route.params.id,
          numero: '',
          date: this.formatDate(),
          status: 'Draft',
          products: [
            {
              id: null,
              quantity: null,
              comments: '',
              buyPrice: 0,
              sellPrice: 0,
              taxes: [],
              product_lot_id: null,
              stock_alert: 10,
              stock_security: 10,
              otherPrice: [
                {
                  name: "",
                  value: ""
                }
              ]
            }
          ],
        };
        $("#remove_enty_product0").val("");
        $("#remove_enty_taxe0").val("");
        $(".kt_select2[data-product-key='0'][name='taxes[]']").val([]).trigger('change');
        $(".kt_select2[data-product-key='0'][name='product']").val('').trigger('change');
        $("#entryItemsModal").modal('toggle')
        this.table.ajax.reload()
        this.$stopLoading('kt_submit_create_entry')
        return true
      } catch (err) {
        this.$stopLoading('kt_submit_create_entry')
      }
    },

    dropShopLigne(key) {
      if (this.formEntryContent.products?.length >= 2) {
        this.formEntryContent.products.splice(key, 1)
      }
    },

    async createTaxData() {
      this.$loading('kt_submit_create_taxe')

      let response = {}

      try {
        response = await this.createTaxe(this.formCreateTaxeData)
        window.toastr['success'](response.data.message)

        let res = await this.showShop(this.$route.params.id)
        this.getTaxes = res.data.taxes

        $('#createTaxeModal').modal('toggle')
        this.formCreateTaxeData = {
          name: '',
          type: '',
          amount: '',
        }
        this.$stopLoading('kt_submit_create_taxe')
        return true

      } catch (err) {
        this.$stopLoading('kt_submit_create_taxe')
        window.toastr['error'](err)
        // this.formCreateProductData.productSaleElements = []

      }
    },

    fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_shop_entries").DataTable({
        destroy:true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[1, 'desc']],
        ajax: {
          url: BASE_URL + '/get/shop/' + this.$route.params.id + '/entries/datatables',
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {
          }
        },
        columns: [{ data: "numero" }, { data: "date" }, { data: "store" }, { data: "user" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -5,
            orderable: false,
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -4,
            className: "dt-center clickable" ,
            render: function (t, a, e, l) {
              return '<span data-id="'+ e.id +'">' + formatDate(t) + "</span>";
            },
          },
          {
            targets: -3,
            orderable: false,
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              if (!t) {
                return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + "___" + "</span>";
              }
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -2,
            orderable: false,
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = ""

              if(e.type == "output"){
                if(this.$can('entry_boutique_update')  ){
                  render+='<button type="button" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-light-primary validate_entry_btn"> Valider </button>'
                }
              }else{
                if(this.$can('entry_boutique_view')  ){
                  render+='<button data-bs-toggle="modal" data-bs-target="#kt_modal_2" type="button" data-store="'+ e.store +'" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto view_btn">' +
                      '<i data-store="'+ e.store +'" data-row="'+ l.row +'" data-id="'+ e.id +'"   class="fa fa-eye"></i>' +
                      '</button> '
                }

              }

              return render
            },
          }
        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },

    loadProductsBySelectedCategories() {
      this.formByCategory.products = [];
      this.categoryProducts = [];

      this.selectedCategories.forEach(catId => {
        const filtered = this.getProductSaleElements.filter(
            p =>  p.product_category_id === catId
        );

        // Ajouter à categoryProducts pour info
        this.categoryProducts.push(...filtered);

        // Ajouter à formByCategory
        filtered.forEach(p => {
          this.formByCategory.products.push({
            id: p.id,
            name: p.declination_title,
            quantity: 1,
            buyPrice: p.price || 0,
            sellPrice: p.price || 0,
            taxes: [],
            stock_alert: p.stock_alert || 10,
            stock_security: p.stock_security || 10,
            product_lot_id: null
          });
        });
      });

      this.$nextTick(() => this.initSelect2());
    },

    filterLots(productId) {
      return this.porductSaleElementLots.filter(l => l.product_sale_element_id === productId);
    },

    removeProductCategory(index) {
      this.formByCategory.products.splice(index, 1);
    },

    priceTTC(item) {
      let price = Number(item.sellPrice);
      const taxes = this.getTaxes.filter(t => item.taxes.includes(t.id));
      taxes.forEach(t => {
        price += t.type === "percent" ? (price * t.amount / 100) : Number(t.amount);
      });
      return Math.round(price * 100) / 100;
    },

    async submitEntryByCategory() {
      this.$loading('kt_submit_create_category_entry');

      try {
        // On utilise la même fonction que pour ajouter les produits à la boutique
        await this.addProductsToShop({
          ...this.formEntryContent,        // Même structure que pour l'autre modal
          products: this.formByCategory.products
        });

        // Recharger la table ou la vue parent
        this.$emit('reloadEditData');

        // Notification succès
        window.toastr['success'](i18n.global.t('notification.store.entrie_create'));

        this.formByCategory = {};
            this.categoryProducts = [];
        // Réinitialiser le formulaire
        this.formEntryContent = {
          shop_id: this.$route.params.id,
          numero: '',
          date: this.formatDate(),
          status: 'Draft',
          products: [
            {
              id: null,
              quantity: null,
              comments: '',
              buyPrice: 0,
              sellPrice: 0,
              taxes: [],
              product_lot_id: null,
              stock_alert: 10,
              stock_security: 10,
              otherPrice: [
                {
                  name: "",
                  value: ""
                }
              ]
            }
          ],
        };

        // Réinitialiser les select2 si nécessaire
        $(".kt_select2[name='taxes[]']").val([]).trigger('change');
        $(".kt_select2[name='product']").val('').trigger('change');

        // Fermer le modal
        $("#entryByCategoryModal").modal('toggle');

        // Recharger la table
        this.table.ajax.reload();

        this.$stopLoading('kt_submit_create_category_entry');
        return true;
      } catch (err) {
        this.$stopLoading('kt_submit_create_category_entry');
        console.error(err);
      }
    },


  }
}
</script>

<style scoped>
.entry-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  color: #7e8299;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}
.entry-close-btn:hover,
.entry-close-btn:focus,
.entry-close-btn:active {
  color: #7e8299;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}
.light-danger {
  color: #f1416c;
  border-color: #fff5f8;
  background-color: #fff5f8;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}

.light-primary {
  color: #0b3d87;
  border-color: #f1faff;
  background-color: #f1faff;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>
